<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="reset"
  >
    <div slot="body">
      <bita-ibox :is-loading="isLoadingModal">
        <div slot="body">
          <bita-form ref="form">
            <div slot="body">
              <div class="col-12 row align-items-center mb-3 ">
                <span class="mr-5 ml-4"> وضعیت بار  :</span>
                <div class="btn-group btn-group-toggle">
                  <label
                    class="btn ml-3 active"
                    :class="dataForm.status == 1 && 'btn-primary'"
                    dir="rtl"
                  >
                    <input
                      v-model="dataForm.status"
                      type="radio"
                      name="status"
                      id="option1"
                      value="1"
                    />
                    تایید
                  </label>
                  <label
                    class="btn active px-3"
                    :class="dataForm.status == 2 && 'btn-danger'"
                  >
                    <input
                      v-model="dataForm.status"
                      type="radio"
                      name="status"
                      id="option2"
                      value="2"
                    />
                    رد
                  </label>
                </div>
              </div>
              <div class="row">
                <bita-textarea
                  v-if="statusMessage"
                  name="message"
                  label=" علت عدم تایید بار را بنویسید :  "
                  validation-container-class="col-12"
                  inputClass="form-control"
                  v-model.trim="dataForm.message"
                />
              </div>
            </div>
          </bita-form>
        </div>
      </bita-ibox>
    </div>
    <div slot="footer">
      <bita-bootbutton
        type="primary"
        title="ثبت درخواست"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        class="mr-2"
        type="danger"
        title="بستن"
        icon="fas fa-times"
        data-dismiss="modal"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    requestId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      dataForm: {
        status: "1",
        message: "",
        request_id: "" 
      },
      isLoadingModal: false,
    };
  },
  computed: {
    statusMessage() {
      return this.dataForm.status == 2 ? true : false;
    }
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {

          if ( this.dataForm.status == 2 && ( this.dataForm.message == null || this.dataForm.message.length === 0 ) ) {
            this.$izitoast(
              "error",
              "ناموفق",
              "باید دلیل خود را برای انصراف بار بنویسید!"
            );
            return;
          }

          this.dataForm.request_id = this.requestId
          this.$emit("on-submit", this.dataForm);
          this.dataForm = {
            status: "1",
            message: "",
            request_id: "" 
          }
        }
      });
    },
  },
};
</script>